import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';

@Injectable()
export class YoutubeRedirectGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const community = this.authenticationService.community;
        const urlSearchParams = new URLSearchParams(route.queryParams);
        const youtubeToken = urlSearchParams.get('code');

        if (community) {
            if (youtubeToken) {
                this.router.navigate([`/${community}/community/installation/youtube`], {
                    queryParams: { code: youtubeToken },
                });
            } else {
                this.router.navigate([`/${community}/community/installation/youtube`]);
            }
        }

        return true;
    }
}
